// extracted by mini-css-extract-plugin
export var body = "components-banners-__MissedTap-module___body";
export var btn = "components-banners-__MissedTap-module___btn";
export var plainBtn = "components-banners-__MissedTap-module___plainBtn";